<template>
  <el-form
      ref="form"
      :model="form"
      label-width="120px">
      <div class="form-content">
        <div class="content-col">
          <el-form-item
            label="广告活动名称"
            prop="campaignName"
            :rules="[
              { required: true, validator: validatorName, trigger: ['change'] }
            ]">
          <template #label>
            <span>广告活动名称</span>
            <gj-help style="padding-left: 3px">广告活动名称仅对您可见，因此请选择一个您可以轻松识别并在日后参考的名称。</gj-help>
          </template>
          <gj-input
              v-model="form.campaignName"
              width="334px"
              placeholder="请输入">
          </gj-input>
        </el-form-item>
        </div>
        <div class="content-col">
          <el-form-item
            class="date-input-group">
            <template #label>
              <span style="color: #F56C6C; margin-right: 4px;">*</span>广告活动时间
              <gj-help style="padding-left: 3px">	您的广告活动开始结束日期，广告活动只在您设置的日期内生效。不填写“结束日期”表示广告会一直生效，创建后也可自由修改“结束日期”</gj-help>
            </template>
            <el-form-item
                class="no-margin"
                prop="startDate"
                :rules="[
                  { required: true, message: '请选择开始日期', trigger: ['blur', 'change'] }
                ]">
              <gj-date-picker
                  v-model="form.startDate"
                  width="155px"
                  :clearable="false"
                  :disabledDate="startDisabledDate"
                  placeholder="开始日期(必填)">
              </gj-date-picker>
            </el-form-item>
            <span style="margin: 0 10px">-</span>
            <el-form-item class="no-margin">
              <gj-date-picker
                  v-model="form.endDate"
                  width="155px"
                  :disabledDate="endDisabledDate"
                  placeholder="无结束日期(选填)">
              </gj-date-picker>
            </el-form-item>
          </el-form-item>
        </div>
        <div class="content-col">
              <el-form-item
                prop="portfolioId">
              <template #label>
                <span>广告组合</span>
                <gj-help style="padding-left: 3px">	组合是一组可以设置预算上限的广告活动。组合使您可以对广告活动进行分组和组织。</gj-help>
              </template>
              <gj-select
                  v-model="form.portfolioId"
                  width="334px"
                  :options="portfolioOption"
                  placeholder="无广告组合"
                  @input-option="portfolioOptionInput">
              </gj-select>
            </el-form-item>
        </div>
        <div class="content-col">
          <el-form-item
              prop="budget"
              :rules="[
                { required: true, message: '请输入每日预算', trigger: ['blur', 'change'] },
                $gjReRule(RE.num(2), '请输入两位小数正数'),
                $gjMinRule(1, '应大于等于1'),
              ]">
              <template #label>
                <span>每日预算</span>
                <gj-help style="padding-left: 3px">您愿意每天为该广告活动花费的金额。如果广告活动支出低于您的每日预算，则剩余金额可用于增加该日历月的其他日期的每日预算，最多可增加 25%。</gj-help>
              </template>
            <gj-input
                v-model="form.budget"
                width="334px"
                placeholder="请输入">
              <template #prepend>{{adStore.SP.currencySymbol}}</template>
            </gj-input>
          </el-form-item>
        </div>
      </div>
      <el-form-item
          prop="targetingType"
          class="form-margin-24"
          :rules="[
            { required: true, message: '请输入投放类型', trigger: ['blur', 'change'] }
          ]">
          <template #label>
            <span>投放类型</span>
            <gj-help style="padding-left: 3px">自动投放：亚马逊将定向到关键词和与您广告中的商品类似的商品。<br />手动投放：选择可定向到顾客搜索的关键词或商品并设置自定义竞价。</gj-help>
          </template>
        <el-radio-group
            v-model="form.targetingType">
          <el-radio
              v-for="item in AdCampaignEnum.SP.targetingTypeOption"
              :key="item.id"
              :label="item.id">
            {{item.text}}
          </el-radio>
        </el-radio-group>
      </el-form-item>
  </el-form>
</template>

<script>
  import { convertToDate } from "@/utils/date.util.js"
  import {adStoreMixin} from "modules/ad/common/mixin";
  import {formMixin, formRuleMixin} from "@/minxins";
  import {AdCampaignEnum} from "modules/ad/common/enum";
  import {disabledEndDate, isMeaningful} from "@/utils/common";
  import { SP } from "@/api/ad"

  export default {
    name: "app-campaign-base-info",
    mixins: [formMixin, adStoreMixin, formRuleMixin],
    props: {
      maxTime: {
        default: false
      },
      marketId: {
        default: false
      },
    },
    data() {
      return {
        AdCampaignEnum: AdCampaignEnum,
        validatorName: this._.debounce((rule, value, callback) => {
          if (!value) return callback(new Error('请输入广告活动名称'));
          const params = {
            marketId: this.marketId,
            name: value
          }
          SP.existByName(params).then(({data}) => {
            data ? callback('广告活动名称已存在') : callback()
          })
        }, 500),
        disabledEndDate: disabledEndDate(new Date()),
        startDisabledDate: (time) => {
          let date = convertToDate(time) + " 23:59:59"
          if (this.maxTime && new Date(date).getTime() <= new Date(this.maxTime).getTime()) {// 按照站点时间计算，时间选项禁用掉过去时间的选择
            return true
          }
          return false
        },
        endDisabledDate: (time) => {
          let date = convertToDate(time) + " 23:59:59"
          if (this.maxTime && new Date(date).getTime() <= new Date(this.maxTime).getTime()) {// 按照站点时间计算，时间选项禁用掉过去时间的选择
            return true
          }
          if (new Date(date).getTime() <= new Date(this.form.startDate).getTime()) {
            return true
          }
          return false
        },
      };
    },
    computed: {
      portfolioOption() {
        return (this.adStore.SP.portfolios || []).map(e => ({
          id: e.portfolioId,
          text: e.portfolioName,
        }));
      }
    },
    methods: {
      portfolioOptionInput(option) {
        this.form.portfolioName = isMeaningful(option) ? option.text : null;
      },
      formValidate() {
        return new Promise((resolve, reject) => {
          this.$refs.form.validate(valid => {
            valid ? resolve() : reject()
          });
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
   /deep/ .date-input-group .el-form-item__content {
     display: flex;
     align-items: center;
   }
   .form-content {
     display: flex;
     flex-wrap: wrap;
     .content-col {
       padding-right: 100px;
       &:nth-child(2n) {
         padding-right: 0;
       }
     }
   }
</style>
